/**
 * Copyright Mántum All Rights Reserved.
 */
import Card from './card';
import Chart from './chart';
import LicenseKey from 'devextreme/core/config';

import type { DataSource, Theme } from '@mantum/kanela';
import type { Limit, Series } from './type';
import type { Palette } from 'devextreme/common/charts';

type PropTypes = {
    advanced?: {
        allowCrosshair?: boolean;
        allowExporting?: boolean;
        allowLegend?: boolean;
        allowTooltip?: boolean;
        entity?: string;
        refresh?: number;
        revalidate?: boolean;
        type?: 'simple' | 'playful';
    };
    dataSource?: DataSource | unknown[];
    icon?: string;
    limit?: Limit;
    name?: string;
    series?: Series;
    subtitle?: string;
    theme?: Theme;
    title?: string;
    type?:
        | 'bar'
        | 'area'
        | 'line'
        | 'spline'
        | 'donut'
        | 'doughnut'
        | 'pie'
        | 'card';
};

LicenseKey({
    licenseKey: import.meta.env.VITE_DEVEXTREME_KEY ?? ''
});

export default function Main(props: PropTypes) {
    const type = props.type;

    if (type === 'card') {
        return (
            <Card
                {...props}
                dataSource={
                    !Array.isArray(props.dataSource)
                        ? props.dataSource
                        : undefined
                }
                type={props.advanced?.type}
            />
        );
    }

    return <Chart {...props} type={type} theme={props.theme as Palette} />;
}
